import { buildSuggestionEditRequest } from '../../utils/optimizerSuggestionApply';

// Optimization opts in; the existing Performance/Run Full Analysis caller keeps
// the original builder and execution path.
export function buildWorkspaceSuggestionEdit(suggestion, scope) {
  const built = buildSuggestionEditRequest(suggestion, scope);
  const value = v => (typeof v === 'number' || typeof v === 'string') && String(v).trim() !== '' && Number.isFinite(Number(v)) && Number(v) > 0;
  if (!built.error && !built.edits && !built.configPayload
    && ['google-ads-search', 'google_search', 'search'].includes(scope.destination)
    && suggestion.action_type === 'budget' && suggestion.target_type === 'campaign'
    && String(suggestion.target_id) === String(scope.platformCampaignId)
    && value(suggestion.current_value) && value(suggestion.recommended_value)) {
    return { ...built, edits: [{ editId: 'optimization-budget', operation: 'set_field',
      field: 'dailyBudget', entityType: 'campaign', targetEntities: [String(suggestion.target_id)],
      platformCampaignId: String(scope.platformCampaignId), oldValue: Number(suggestion.current_value),
      value: Number(suggestion.recommended_value), description: built.description }] };
  }
  return built;
}
